import { Pipe, PipeTransform } from '@angular/core';
import {CurrencyPipe} from '@angular/common';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
    name: 'currencyFormat',
    pure: false // required to update the value when currentLang is changed
})
export class CurrencyFormatPipe implements PipeTransform {
    constructor(private translate: TranslateService) {}
    transform(
        amount: any,
        currencyCode: string = 'SEK',
        display: 'code' | 'symbol' | 'symbol-narrow' = 'symbol',
        digits: string = '1.2-2',
        locale?: string): string {

        const currentLang = locale !== undefined ? locale : this.translate.currentLang;
        const currencyPipe = new CurrencyPipe(currentLang);

        return currencyPipe.transform(amount, currencyCode, display, digits);

    }
}



// WEBPACK FOOTER //
// ./src/app/pipes/currency-fomat.pipe.ts